/**
 * @fileoverview Four-stat strip just below the hero. Mirrors the
 * dashboard stat-card wash so the bar reads as part of the same
 * palette-driven surface family.
 *
 * Extracted verbatim out of the original Landing/index.tsx.
 */
import { STATS } from '../constants'

export function StatBar() {
  return (
    // Same bottom-to-top mint wash the dashboard stat cards use, applied
    // to the full-width strip so the section reads as part of the same
    // palette-driven surface family as the rest of the page.
    <section className="relative border-y border-primary/10 overflow-hidden">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-gradient-to-t from-primary/8 via-primary/2 to-transparent"
      />
      <div className="relative mx-auto grid max-w-7xl grid-cols-2 gap-6 px-4 py-8 sm:px-6 md:grid-cols-4 lg:px-8">
        {STATS.map((s) => {
          const Icon = s.icon
          return (
            <div key={s.label} className="flex items-center gap-3">
              <div className="rounded-md bg-primary/10 p-2 text-primary">
                <Icon className="h-5 w-5" />
              </div>
              <div>
                <p className="text-xl font-bold tabular-nums">{s.value}</p>
                <p className="text-xs text-muted-foreground">{s.label}</p>
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}
